import { useMemo, useState } from "react";
import { useDispatch } from "react-redux";
import { login } from "../../features/auth.slice";
import { auth } from "../../firebase";
import {
  browserSessionPersistence,
  setPersistence,
  signInWithCustomToken
} from "firebase/auth";
import { useNavigate } from "react-router-dom";
import { alertOpen, AlertValue } from "../../features/alert.slice";
import { ButtonLoading } from "../../components/spinner/Spiner";
import Button from "../../components/button/Button";
import yup from "../../utility/ValidationUtilty";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import FormController from "../../components/fields/FormController";
import { getTenantId } from "../../utility/FireStoreUtility";
import authApi from "../../api/Auth.api";
import { Result } from "../../model/Result";
import { ConstMessage } from "../../config/const";

export const Portal = () => {
  const dispatch = useDispatch();
  const navigation = useNavigate();
  const [isload, setIsLoad] = useState(false);

  interface LoginForm {
    tenantId: string;
    userId: string;
    password: string;
  }
  // バリデーションルール
  const schema = yup.object({
    tenantId: yup.string().required(),
    userId: yup.string().required(),
    password: yup.string().required()
  });

  const { control, handleSubmit } = useForm<LoginForm>({
    resolver: yupResolver(schema),
  });

  useMemo(() => {
    (async () => {
      document.title = `ジョイン マイページ`
    })();
  }, []);

  //ログイン
  const onSubmit = async (data: LoginForm) => {
    setIsLoad(true);
    const tenantIdValue = await getTenantId(data.tenantId)
    if(!tenantIdValue.success){
      dispatch(
        alertOpen(AlertValue("ご確認ください。", "danger", "団体番号が間違っています。"))
      );
      setIsLoad(false);
      return;
    }
    auth.tenantId = tenantIdValue.data as string;

    setPersistence(auth, browserSessionPersistence);
    var userToken : Result = await authApi.requestPortalUserToken(
      data.tenantId,
      data.userId,
      data.password,
    );
    if (userToken.data.success) {
      signInWithCustomToken(auth, userToken.data.token)
        .then(async (userCredential) => {
          // Signed in
          dispatch(login(userCredential));
          sessionStorage.setItem("jwt", userToken.data.token);
          navigation("/portal/");
      })
      .catch((error) => {
        console.log(error);
        console.error(error.code);
        dispatch(
          alertOpen(AlertValue(ConstMessage.ERR_LOGIN, "danger"))
        );
        setIsLoad(false);
      })
    } else {
      setIsLoad(false);
      dispatch(
        alertOpen(AlertValue(ConstMessage.ERR_LOGIN, "danger"))
      );
    }
  };

  const loginPage = () => {
    return (
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10">
          <form
            className="space-y-6"
            onSubmit={handleSubmit(onSubmit)}
            method="POST"
          >
            <FormController
              control={control}
              name={"tenantId"}
              label={"団体番号"}
              type={"tenantId"}
            />
            <FormController
              control={control}
              name={"userId"}
              label={"利用者番号"}
              type={"userId"}
            />
            <FormController
              control={control}
              name={"password"}
              label={"パスワード"}
              type={"password"}
            />

            <div>
              <Button submit disabled={isload} color={"darkOrange"} block>
                {isload ? <ButtonLoading /> : "ログイン"}
              </Button>
            </div>
          </form>
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="bg-[#fcfafd] flex min-h-full flex-col justify-center sm:px-6 lg:px-8">
        <div className="sm:mx-auto sm:w-full sm:max-w-md">
          <h2 className="text-center text-3xl font-bold tracking-tight text-gray-900">
            ジョイン マイページ
          </h2>
        </div>
        {loginPage()}
      </div>
    </>
  );
};